import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, InputNumber } from "antd";
import InputForm from "./InputForm";
import UsuarioFrame from '../components/UsuarioFrame';
import "./Form.css";

const { Item: ItemForm } = Form;

export default class UsuarioMetaForm extends Component {
  state = {
    registro: {
      um_idf: '',
      um_usuario: '',
      um_mes: new Date().getMonth() + 1,
      um_ano: new Date().getFullYear(),
      um_valor: 0,
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        // this.refs.registro.um_usuario.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['um_usuario'] = event.um_usuario;
    this.setState(event);
  }

  onInputChangeMes = event => {
    const { registro } = this.state;
    registro['um_mes'] = event;
    this.setState(registro);
  }

  onInputChangeAno = event => {
    const { registro } = this.state;
    registro['um_ano'] = event;
    this.setState(registro);
  }


  onOK = () => {
    if ((!this.state.registro.um_usuario) || (this.state.registro.um_usuario.key === '0') || (this.state.registro.um_usuario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Vendedor', });
      return;
    }
    if (!this.state.registro.um_valor) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor da Meta' });
      return;
    }

    this.state.registro.um_usuario = this.state.registro.um_usuario.key;

    this.props.onSalvarClick(this.state.registro);
  };





  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { um_idf, um_usuario, um_mes, um_ano, um_valor } = this.state.registro;

    // console.log('UsuarioMetaForm: ', this.state);

    return (
      <Modal
        title={um_idf ? "Edição de Meta" : "Cadastro de Meta"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24}>
              <UsuarioFrame
                label="Vendedor"
                id="um_usuario"
                value={um_usuario}
                width={"100%"}
                vendedor={1}
                todasEmpresas={this.state.usuario ? this.state.usuario.emp_codigo : 999999}
                onChange={this.onChangeVendedor}
                descricaoPrimeiroItem="Selecione um Vendedor"
                disabled={um_idf ? true : false}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <Row>
                <span>Mês</span>
              </Row>
              <Row>
                <InputNumber
                  ref="Input"
                  id={um_mes}
                  value={um_mes}
                  onChange={this.onInputChangeMes}
                  min={1}
                  max={12}
                  maxLength={2}
                  disabled={um_idf ? true : false}
                  style={{ width: "100%" }}
                />
              </Row>
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <Row>
                <span>Ano</span>
              </Row>
              <Row>
                <InputNumber
                  ref="Input"
                  id={um_ano}
                  value={um_ano}
                  onChange={this.onInputChangeAno}
                  min={2020}
                  max={2100}
                  maxLength={4}
                  disabled={um_idf ? true : false}
                  style={{ width: "100%" }}
                />
              </Row>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -25 }}>
              <span>Valor Meta</span>
              <InputForm
                type="number"
                id="um_valor"
                ref="um_valor"
                value={um_valor}
                onChange={this.onChange}
              />
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UsuarioMetaForm.js